"use client"
import { useMediaQuery } from '@/lib/useMediaQuery'
import { PlanATimelineDiagram } from './PlanATimelineDiagram'
import { PlanATimelineDiagramMobile } from './PlanATimelineDiagramMobile'
import { type PlanATimelineDiagramProps } from './planATimelineDiagramModel'

// Picks the horizontal timeline on desktop and the stacked variant on phones.
export const PlanATimelineDiagramResponsive = (props: PlanATimelineDiagramProps) => {
  const isMobile = useMediaQuery('(max-width: 767px)')
  if (!isMobile) {
    return <PlanATimelineDiagram {...props} />
  }
}
